/* src/app/_shared/components/appointment-pill/appointment-pill.component.scss */
:host {
  display: block;
  font-weight: inherit;
  --background-color: var(--ion-color-primary);
  --buttons-background-color: var(--ion-color-secondary);
  --color: var(--ion-color-action-contrast);
  --buttons-color: var(--ion-color-primary-contrast);
  --font-size: 18px;
  --font-weight: normal;
  --width: auto;
  --text-transform: capitalize;
}
:host[icon] .appointment-pill {
  padding-top: calc(var(--space-top) * 0.75);
  padding-bottom: calc(var(--space-bottom) * 0.75);
}
.appointment-pill {
  display: inline-flex;
  flex-flow: row wrap;
  align-items: center;
  padding: var(--space-top) calc(var(--space-right) / 1) var(--space-bottom) calc(var(--space-left) / 1);
  border-radius: var(--radius);
  background-color: var(--background-color);
  color: var(--color);
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  text-transform: var(--text-transform);
  vertical-align: center;
}
.appointment-pill ion-icon {
  margin-top: -2px;
  margin-right: calc(var(--space-right) / 2);
  margin-left: -4px;
  font-size: var(--icon-size);
  vertical-align: middle;
}
.appointment-pill .content {
  width: var(--width);
}
.appointment-pill .time-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin-left: calc(var(--space-left) / 2);
  background-color: var(--buttons-background-color);
  color: var(--buttons-color);
  font-size: 20px;
  border-radius: 50%;
}
.appointment-pill .time-button .plus-char {
  height: 27px;
}
/*# sourceMappingURL=appointment-pill.component.css.map */
